import { render } from "./TestResultStudent.vue?vue&type=template&id=55044877&scoped=true"
import script from "./TestResultStudent.vue?vue&type=script&lang=js"
export * from "./TestResultStudent.vue?vue&type=script&lang=js"

import "./TestResultStudent.vue?vue&type=style&index=0&id=55044877&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55044877"]])

export default __exports__